var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "absolute z-10 left-0 top-header-main-desktop mobile+tablet:hidden w-full h-screen transform"
      ]
    },
    [
      _c("div", {
        class: ["z--1 absolute inset-0 bg-grey-800 opacity-70 cursor-pointer"],
        on: {
          click: function($event) {
            return _vm.closeDesktopMegamenu(true)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          class: ["absolute z-10 top-0 left-0 bg-white pt-4 pb-22.5 w-full"],
          on: {
            mouseover: function($event) {
              return _vm.openDesktopMegamenu(_vm.navItem.id)
            },
            mouseleave: function($event) {
              return _vm.closeDesktopMegamenu(false)
            }
          }
        },
        [
          _c("div", { staticClass: "o-wrapper" }, [
            _vm.navItem.heading
              ? _c("div", {
                  class: [
                    "text-md leading-base content mb-4 text-heading font-bold"
                  ],
                  domProps: { innerHTML: _vm._s(_vm.navItem.heading) }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "flex" }, [
              _c(
                "div",
                { staticClass: "w-full" },
                [
                  _c("MegamenuTwoStepBox", {
                    attrs: { type: _vm.type, navItems: _vm.mainChildren }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "min-w-[408px]" },
                [
                  _c("NavPostcodeBox", {
                    attrs: {
                      type: _vm.type,
                      navItems: _vm.sideLinks,
                      communities: _vm.communities,
                      nearbyRedirectUrl: _vm.nearbyRedirectUrl,
                      enquireUrl: _vm.enquireUrl
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }